import { ComponentBread, ComponentHeader, StyledCreate } from "@components";
import { PATH_CLIENT_CREATE, PATH_CLIENT_INFO } from "@configs";
import { CdicClientForm } from "@modules/clients/CdicForm";
import { useClientDetail } from "@utils";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useParams } from "react-router";

export const PageCreateCdicClient = () => {
  const { id } = useParams<{ id: string }>();
  const { t } = useTranslation();
  const history = useHistory();
  const { data: client, isError } = useClientDetail(id, "cdic");

  useEffect(() => {
    if (isError) {
      history.goBack();
    }
  }, [history, isError]);

  const data = [
    {
      title: <a href={PATH_CLIENT_INFO || ""}>{t("page.client_information")}</a>,
    },
    {
      title: <a href={PATH_CLIENT_CREATE || ""}>{t("page.add_client")}</a>,
    },
  ];

  return (
    <>
      <ComponentHeader title={t("page.add_client")} />
      <StyledCreate>
        <ComponentBread pages={data} />
        <CdicClientForm client={client} />
      </StyledCreate>
    </>
  );
};
